import React from 'react';
import TrackImage from '../../assets/TrackImage.png'; // Replace with your actual image file path

function TrackLocation() {
  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100">
      <img src={TrackImage} alt="Track Location" className="h-auto w-full" />
    </div>
  );
}

export default TrackLocation;
